import { alias, createModelSchema, custom, deserialize, list, serialize, SKIP } from "serializr";
import { BaseObject } from "@/common/BaseObject";
import { GuardTime } from "../guard/GuardTime";
import { LevelTrackReward } from "./LevelTrackReward";
import { LevelTrackLevel } from "./LevelTrackLevel";

export class LevelTrack extends BaseObject {

    constructor() {
        super();

        this._guardTime = new GuardTime();
        this._availableRewards = [];
        this._levels = [];
    }

    get guardTime() {
        return this._guardTime;
    }

    set guardTime(value) {
        this._guardTime = value;
    }

    get availableRewards() {
        return this._availableRewards;
    }

    set availableRewards(value) {
        this._availableRewards = value;
    }

    get levels() {
        return this._levels;
    }

    set levels(value) {
        this._levels = value;
    }

    valid() {
        if (this.guardTime && !this.guardTime.valid()) {
            return false;
        }

        if (!this.availableRewards || this.availableRewards.length === 0) {
            return false;
        }

        if (this.availableRewards.some(v => !v.valid())) {
            return false;
        }

        if (!this.levels || this.levels.length === 0) {
            return false;
        }

        if (this.levels.some(v => !v.valid())) {
            return false;
        }

        return super.valid();
    }

    empty() {
        return !this.guardTime && (!this.availableRewards || this.availableRewards.length === 0) && (!this.levels || this.levels.length === 0) && super.empty();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new LevelTrack());
        } else if (target instanceof LevelTrack) {
            return super.clone(target);
        } else {
            return undefined;
        }
    }

    static schema() {
        return custom((v) => {
            return v && !v.empty() ? serialize(LevelTrack, v) : SKIP;
        }, (v) => {
            return deserialize(LevelTrack, v);
        });
    }
}

createModelSchema(LevelTrack, {
    _guardTime: alias("guard_time", GuardTime.schema()),

    _availableRewards: alias("available_rewards", list(LevelTrackReward.schema())),
    _levels: alias("levels", list(LevelTrackLevel.schema())),
});
